import { render } from "./TheHeroSection.vue?vue&type=template&id=2a5d23c1"
import script from "./TheHeroSection.vue?vue&type=script&lang=js"
export * from "./TheHeroSection.vue?vue&type=script&lang=js"

import "./TheHeroSection.vue?vue&type=style&index=0&id=2a5d23c1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__